export default __webpack_public_path__ + "8c264497b3018f01e5e409433cced090.svg";